import UntitledIcon from '@payaca/untitled-icons';
import React from 'react';

interface Props {
  errorId?: string;
}

const ErrorBoundaryFallback: React.FC<Props> = ({ errorId }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg bg-red-50 p-4">
      <div className="text-center">
        <UntitledIcon
          name="info-circle.3"
          className="mb-4 text-4xl text-red-500"
        />
        <h2 className="mb-2 text-lg font-semibold text-gray-900">
          An unexpected error occurred
        </h2>
        {errorId && (
          <div className="max-w-[37.33rem] p-4">
            <p className="text-sm text-gray-700">
              <strong>Error ID:</strong> {errorId}
            </p>
            <p className="mt-1 text-sm text-gray-500">
              Reference this ID when contacting support
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
